import { useEffect, useState, useRef, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';
import DeviceRow from './DeviceRow';
import { useSelector } from 'react-redux';

const useStyles = makeStyles()((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
  },
  deviceList: {
    padding: theme.spacing(1),
  },
}));

const DeviceList = ({ devices = [] }) => {
  const { classes } = useStyles();
  const containerRef = useRef(null);
  const [visibleDevices, setVisibleDevices] = useState([]);
  const positions = useSelector((state) => state.session.positions);

  // Memoizar a lista de dispositivos para evitar rerenders desnecessários
  const safeDevices = useMemo(() =>
    Array.isArray(devices) ? devices : [],
    [devices]
  );

  // Implementação otimizada de virtualização
  useEffect(() => {
    const updateVisibleDevices = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const scrollTop = container.scrollTop;
      const containerHeight = container.clientHeight;
      const itemHeight = 102;

      const startIndex = Math.max(0, Math.floor(scrollTop / itemHeight) - 2);
      const endIndex = Math.min(
        safeDevices.length - 1,
        startIndex + Math.ceil(containerHeight / itemHeight) + 4
      );

      setVisibleDevices(safeDevices.slice(startIndex, endIndex + 1));
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', updateVisibleDevices);
      updateVisibleDevices();

      return () => {
        container.removeEventListener('scroll', updateVisibleDevices);
      };
    }
  }, [safeDevices]);

  // Calcular altura total da lista para o scroll
  const totalHeight = safeDevices.length * 102;

  return (
    <div ref={containerRef} className={classes.container}>
      <div style={{ height: totalHeight, position: 'relative' }}>
        {visibleDevices.map((device) => {
          const actualIndex = safeDevices.findIndex(d => d.id === device.id);
          return (
            <div
              key={device.id}
              style={{
                position: 'absolute',
                top: actualIndex * 102,
                width: '100%',
                height: 102,
              }}
            >
              <DeviceRow
                device={device}
                position={positions[device.id]}
              />
            </div>
          );
        })}
      </div>
      {safeDevices.length === 0 && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          color="text.secondary"
        >
          Nenhum dispositivo encontrado
        </Box>
      )}
    </div>
  );
};

export default DeviceList;